import * as Styled from "./styles";

export default function PageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <Styled.Rect x="0.5" y="0.5" width="43" height="43" rx="21.5" />
      <Styled.Path d="M16.0985 22.5855L23.7967 29.3659L23.018 30.25L13.6514 22L23.018 13.75L23.7967 14.6341L16.1066 21.4074L28.9708 21.4176L28.9699 22.5957L16.0985 22.5855Z" />
    </svg>
  );
}
